import { HelpDetails } from 'app/shared/help_and_information/HelpRegistry';
import {
    PLACEMENT_BOTTOM,
    TOUR_TYPE__NAVIGATED_TOUR,
} from 'app/shared/help_and_information/tours/TourService';

export const topbarHelpDetails: HelpDetails = {
    key: 'topbar',
    header: 'Topbar',
    descriptionHtml: `
        <p>The <span class="ims-name">Topbar</span> provides quick access to app wide IMS actions.</p>
    `,
    tourType: TOUR_TYPE__NAVIGATED_TOUR,
    hiddenTags: ['share', 'url', 'kmz'],
    innerTourSteps: [
        {
            title: 'Saving Indicator',
            content: `
                <p>Changes to orange when IMS is performing a background save operation.</p>
            `,
            target: 'topbar-saving-indicator',
            xOffset: -25,
            yOffset: 2,
            placement: PLACEMENT_BOTTOM,
        },
        {
            title: 'Site Selector',
            content: `
                <p>Sets the currently active <span class="ims-name">Site</span>.</p>
            `,
            target: 'topbar-site-selector',
            xOffset: -20,
            yOffset: 20,
            placement: PLACEMENT_BOTTOM,
        },
        {
            title: 'View Selector',
            content: `
                <p>Sets the currently active <span class="ims-name">View</span>.</p>
            `,
            target: 'topbar-view-selector',
            xOffset: -20,
            yOffset: 20,
            placement: PLACEMENT_BOTTOM,
        },
        {
            title: 'Current Selection',
            content: `
                <p>A list of currently selected IMS items.</p>
                <p>Items can be selected from lists in the <span class="ims-name">Center Pane</span> or from the <span class="ims-name">Map</span>.</p>
                <p>Hold <i>Ctrl</i> to select multiple items.</p>
            `,
            target: 'topbar-selected',
            arrowOffset: 'center',
            xOffset: -120,
            placement: PLACEMENT_BOTTOM,
        },
        {
            title: 'New Comments',
            content: `
                <p>Drops down on click, showing a list of unread <span class="ims-name">Comments</span> and those made in the last 24 hours.</p>
            `,
            target: 'topbar-new-comments',
            arrowOffset: 270,
            xOffset: -285,
            placement: PLACEMENT_BOTTOM,
        },
        {
            title: 'Alerting Triggers',
            content: `
                <p>Drops down on click, showing a list of alerting <span class="ims-name">Triggers</span>.</p>
            `,
            target: 'topbar-alerts',
            arrowOffset: 270,
            xOffset: -285,
            placement: PLACEMENT_BOTTOM,
        },
        {
            title: 'Share Link / KMZ',
            content: `
                <p><i>Copy link to current view</i> copies a link to the clipboard. This link can be sent to someone else who has access to the IMS and it will duplicate the following in their session:</p>
                <ul>
                    <li>Selected Time</li>
                    <li>Camera Position</li>
                    <li>Selected Site</li>
                    <li>Selected View</li>
                    <li>Selected Assets</li>
                    <li>Selected Zones</li>
                    <li>Selected IP Devices</li>
                </ul>
                <p><i>Download KMZ</i> starts generating a KMZ file of your current view of the map then saves the file locally.
                It can then be opened with a GIS program like Google Earth.</p>
            `,
            target: 'topbar-share',
            arrowOffset: 270,
            xOffset: -285,
            placement: PLACEMENT_BOTTOM,
        },
        {
            title: 'User / Logout',
            content: `
                <p>Shows the currently logged in <span class="ims-name">User</span>. Drops down on click showing a button to logout.</p>
            `,
            target: 'topbar-user',
            arrowOffset: 270,
            xOffset: -285,
            placement: PLACEMENT_BOTTOM,
        },
    ],
};
